import type { SVGProps } from "react";

export const GoogleFinance = (props: SVGProps<SVGSVGElement>) => (
  <svg
    height="1em"
    preserveAspectRatio="xMidYMid"
    viewBox="0 0 512 512"
    width="1em"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <title>Google Finance</title>{" "}
    <g fill="none" fillRule="evenodd">
      {" "}
      <path
        d="M0 338.895h512V492.5c0 10.77-8.725 19.5-19.504 19.5H19.504C8.732 512 0 503.267 0 492.5V338.895z"
        fill="#C3C3C3"
      />{" "}
      <path d="M0 173.105h512v165.79H0z" fill="#E3E3E3" />{" "}
      <path
        d="M0 19.5C0 8.73 8.725 0 19.504 0h472.992C503.268 0 512 8.733 512 19.5v153.605H0V19.5z"
        fill="#F2F2F2"
      />{" "}
      <path
        d="M0 392.533L121.905 256l139.552 29.655L512 26.819v465.674c0 10.773-8.725 19.507-19.504 19.507H19.504C8.732 512 0 503.264 0 492.49v-99.957z"
        fill="#17A05D"
      />{" "}
      <path
        d="M0 470.552l124.343-107.276L256 402.286l256-190.172v280.383c0 10.771-8.725 19.503-19.504 19.503H19.504C8.732 512 0 503.26 0 492.49v-21.938z"
        fill="#9FCD69"
      />{" "}
    </g>
  </svg>
);

export default GoogleFinance;
